import React from "react";
import { IAppEntity } from "../../entities";
import { ReferenceTypes } from "../../../enums/ReferenceTypes";
import { DeviceDetail } from "../../../components/Pages/Catalogs/Device/DeviceDetail";
import DeviceList from "../../../components/Pages/Catalogs/Device/DeviceList";
import { CreateDeviceDto } from "../../../dtos/catalogs/Device/CreateDeviceDto";
import { DeviceService } from "../../../services/catalogs/DeviceService";
import { NFLookupDevice } from "../../../components/Shared/NewForms/NFLookupDevice";

export const Device: IAppEntity = {
  entityType: "catalog",
  title: "Device",
  pluralTitle: "Device",
  apiUrl: "Devices",
  apiEnum: ReferenceTypes.CatalogDevice,
  getDetailViewComponent: (
    model: any,
    modelUpdatedEvent: (model: any) => void
  ) =>
    React.createElement(DeviceDetail, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getListView: (model: any, modelUpdatedEvent: (model: any) => void) =>
    React.createElement(DeviceList, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getLookupComponent(model: any): any {
    return React.createElement(NFLookupDevice, {
      fieldName: model.fieldName,
      title: model.title,
      setSelectedCatalog: model.setSelectedCatalog,
    });
  },
  getDataService: () => new DeviceService("Devices"),
  getEmptyModel: () => {
    const model: CreateDeviceDto = {
      name: "",
      createdDate: new Date(),
    };
    return model;
  },
};
